import { isRecognisedOutcome } from './decompositionGate'
import { type CrossClientReviewState } from './hooks'

export const RECOMMENDED_SAMPLE_SIZE = 3

export const shouldShowRecommendedQueries = (reviewState: CrossClientReviewState | null): boolean =>
  reviewState?.kind === 'rejected' && isRecognisedOutcome(reviewState.outcome) && !reviewState.suggestion

export const pickRandomSample = <T>(items: T[], count: number): T[] => {
  const shuffled = items.slice()
  const descendingIndexes = Array.from({ length: shuffled.length - 1 }, (_, i) => shuffled.length - 1 - i)
  descendingIndexes.forEach((i) => {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  })
  return shuffled.slice(0, count)
}
